<template>
  <div>
    <h3>{{ place }}</h3>
    <div>更新日時：{{ updateTime}}</div>
    <div :key="index" v-for="(statuses, index) in statusesList">
      <table>
        <tr>
          <th></th>
          <th :key="time" v-for="time in getTimeTable(statuses)">{{ time }}</th>
        </tr>
        <tr :key="ymd" v-for="(timeStatuses, ymd) in getYmdStatuses(statuses)">
          <th>{{ ymd }}</th>
          <td
            :key="timeStatus.time"
            v-for="timeStatus in timeStatuses"
            :class="getTdClass(timeStatus.count)"
          >
            <template v-if="timeStatus.count == 0">-</template>
            <template v-else>{{ timeStatus.count }}</template>
          </td>
        </tr>
      </table>
      <br />
    </div>
  </div>
</template>

<script>
//import firebase from 'firebase'
import firebase from "firebase/app";
import "firebase/firestore";

export default {
  name: "Status",
  props: ["place", "city", "event"],
  data() {
    return {
      statuses: undefined
    };
  },
  computed: {
    dateList() {
      if (!this.statuses) {
        return [];
      }
      return this.statuses.flatMap(doc => doc.date);
    },
    // 季節の変わり目でタイムテーブルが変わるindex
    seasonIndex() {
      if (!this.statuses) {
        return -1;
      }
      const length = this.dateList[0].time.length;
      return this.dateList.findIndex(date => date.time.length != length);
    },
    statusesList() {
      if (!this.statuses) {
        return [];
      }
      const statusesDate1 =
        this.seasonIndex == -1
          ? this.dateList
          : this.dateList.slice(0, this.seasonIndex);
      const statusesDate2 =
        this.seasonIndex == -1 ? null : this.dateList.slice(this.seasonIndex);
      if (statusesDate2) {
        return [statusesDate1, statusesDate2];
      } else {
        return [statusesDate1];
      }
    },
    updateTime() {
      if (!this.statuses) {
        return "";
      }
      const date = this.statuses[0].timestamp.toDate();
      return (
        "" +
        date.getFullYear() +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );
    }
  },
  created: async function() {
    const db = firebase.firestore();
    const snapshot = await db
      .collection(`${this.city}-status`)
      .where("place", "==", this.place)
      .where("event", "==", this.event)
      .get();
    this.statuses = snapshot.docs.map(doc => doc.data());
  },
  mounted: function() {
    document.title = `${this.place}|休日空き情報`;
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        `${this.place}の休日空き情報を分かりやすく提供しています`
      );
  },
  methods: {
    getTdClass(count) {
      return count == 0 ? "" : "available";
    },
    getTimeTable(statuses) {
      if (!statuses) {
        return "";
      }
      const times = statuses
        //.flatMap(doc => doc.date)
        .flatMap(date => date.time)
        .map(time => time.time);
      return Array.from(new Set(times));
    },
    getYmdStatuses(statuses) {
      if (!statuses) {
        return {};
      }
      return (
        statuses
          //.flatMap(doc => doc.date)
          .reduce((acc, obj) => {
            const key = obj.ymd;
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key] = obj.time;
            return acc;
          }, {})
      );
    }
  }
};
</script>